var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoloYou(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Logo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Logo_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3504 0.791595C22.3825 1.06357 23.199 1.8644 23.4763 2.87676C23.9846 4.72017 24 8.54297 24 8.54297C24 8.54297 24 12.3809 23.4917 14.2092C23.2144 15.2215 22.3979 16.0224 21.3659 16.2943C19.5019 16.793 12 16.793 12 16.793C12 16.793 4.49807 16.793 2.63415 16.2943C1.60205 16.0224 0.785623 15.2215 0.508344 14.2092C0 12.3658 0 8.54297 0 8.54297C0 8.54297 0 4.72017 0.49294 2.89187C0.770218 1.87951 1.58665 1.07868 2.61874 0.806705C4.48267 0.308079 11.9846 0.292969 11.9846 0.292969C11.9846 0.292969 19.4865 0.292969 21.3504 0.791595ZM15.8203 8.54297L9.59692 12.0787V5.00725L15.8203 8.54297Z",
    fill: "#0C5393"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoloYou);
export default __webpack_public_path__ + "static/media/lolo_you.5c62af886aa34c8de84bf17e2cd29ac4.svg";
export { ForwardRef as ReactComponent };